module.exports = "<symbol id=\"thebestco-uikit-svg-Have16\" viewBox=\"0 0 16 16\"><path d=\"M0 8L6 15L16 4L13 1L6 8L3 5L0 8Z\"/></symbol>";